import React from 'react';

import Typography from '../Typography';
import { TimelineContainer } from './style';

interface TimelineEvent {
  date: string;
  title: string;
  description?: string;
  // color?: string;
}

interface TimelineProps {
  events: TimelineEvent[];
}

const Timeline: React.FC<TimelineProps> = ({ events }) => {
  return (
    <TimelineContainer>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        TIMELINE:
      </Typography>
      <div className="vertical-timeline">
        {events?.map((event, index) => (
          <div key={index} className="vertical-timeline-event">
            <Typography className="event-date">{event.date}</Typography>

            <div className="timeline-circle"></div>

            <div className="event-details">
              <Typography className="event-title">{event.title}</Typography>
              {event.description && (
                <Typography
                  variant="smallText"
                  fontColor="border"
                  className="event-description"
                >
                  {event.description}
                </Typography>
              )}
            </div>
          </div>
        ))}
      </div>
    </TimelineContainer>
  );
};

export default Timeline;
